module.exports = __webpack_public_path__ + "img/09.a82d2d09.png";